import React, { useState } from 'react';
import { ReactComponent as Logo } from 'assets/svg/logo.svg';
import Input from 'components/Input';
import RoundedButton from 'components/RoundedButtons';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { emailSubscribe } from 'reduxStore/actions/emailSubscription';
import { toast } from 'react-toastify';
import { setDialogState } from 'reduxStore/reducers/dialogSlice';
import { isLoggedIn } from 'utils/helpers';
import LogoImg from 'assets/image/LOGO - Icon.png';


const Footer = () => {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const { dialogOpenState } = useSelector((state) => state.dialogOpenState);
  const navLinks = {
    pregaCenter: {
      title: 'Prega Center',
      navOptions: [
        {
          title: 'Blogs',
          link: '/blogs',
        },
        {
          title: 'Pregnancy',
          link: '/pregnancy',
        },
        {
          title: 'Baby',
          link: '/baby',
        },
        {
          title: 'Parenthood',
          link: '/parenthood',
        },
        {
          title: 'Family',
          link: '/family',
        },
        {
          title: 'Community',
          link: '/community',
        },
        // {
        //   title: 'Courses',
        //   link: '/courses',
        // },
      ],
    },
    resources: {
      title: 'Resources',
      navOptions: [
        {
          title: 'Mobile App',
          link: '/mobileapp',
        },
        {
          title: 'About Us',
          link: '/aboutus',
        },

        {
          title: 'Contact us',
          link: '/contactus',
        },

        {
          title: 'Privacy Policy',
          link: '/privacypolicy',
        },
        {
          title: 'Terms of Use',
          link: '/termsofuse',
        },
      ],
    },
    connect: {
      title: 'Connect',
      navOptions: [
        {
          title: 'Instagram',
          link: 'https://www.instagram.com/pregacenter/',
        },
        {
          title: 'YouTube',
          link: 'https://www.youtube.com/channel/UCyJ3u9o7365q55896-6433',
        },
        {
          title: 'Facebook',
          link: 'https://www.facebook.com/pregacenter/',
        },
        {
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/pregacenter/',
        },
        {
          title: 'Twitter',
          link: 'https://twitter.com/pregacenter',
        },
      ],
    },
  };
  const handleEmailSubscription = () => {
    if (!email) return;
    console.log(email);
    dispatch(emailSubscribe({ email }))
      .unwrap()
      .then((res) => {
        if (res?.success) {
          toast.success(res?.message);
          setEmail('');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleLinkClick = (e, option) => {
    // Check if it's an external link (starts with http)
    if (option.link.startsWith('http')) {
      return; // Allow normal navigation for external links
    }

    // Protected routes that require login
    const protectedRoutes = [ '/community', '/courses'];
    
    if (protectedRoutes.includes(option.link)) {
      // If user is not logged in, show login modal and prevent navigation
      if (!isLoggedIn()) {
        e.preventDefault();
        dispatch(
          setDialogState({
            ...dialogOpenState,
            logIn: true,
            register: false,
          })
        );
      }
    }
    // For all other routes, allow normal navigation
  };
  return (
    <footer className='w-full flex flex-col mt-8 px-[15px] gap-12 xl:gap-16 2xl:gap-24  py-8 sm:pt-16 sm:pb-[42px] rounded-[28px] sm:rounded-card-rounded bg-[#1A0E12] md:px-10 sm:px-[15px]'>
      <div className='container flex flex-col xl:flex-row justify-between gap-8 xl:gap-52'>
        <div className='flex flex-col justify-center max-w-[480px] flex-shrink-0 gap-8'>
          <div className='flex flex-col gap-3'>
          <img src={LogoImg} alt='Prega Center logo' className='w-[72px] h-[72px]' />

            <h1 className='text-[#9D8F93]'>
              Join our community, access vital tools, and receive tailored
              guidance for every stage of your journey
            </h1>
          </div>
          <div className='relative flex flex-col sm:block gap-3 sm:gap-0 max-w-[90%'>
            <Input
              placeholder='Email Address'
              labelText='Newsletter'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              inputClassName='sm:pr-[150px]'
              labelClassName='text-white'
            />
            <RoundedButton
              onClick={() => handleEmailSubscription()}
              text='Subscribe'
              className='sm:absolute h-[46px] sm:h-12 md:h-[50px] xl:h-[52px] self-center sm:self-auto bottom-0 right-0 text-base'
            />
          </div>
        </div>
        <div className='flex flex-row flex-wrap gap-8 w-[100%] justify-between'>
          <div className='flex flex-col gap-4 '>
            <h2 className='text-white text-xl font-semibold'>
              {navLinks.pregaCenter.title}
            </h2>
            <div className='flex flex-col gap-2'>
              {navLinks.pregaCenter.navOptions.map((option, index) => (
                <Link 
                  to={option.link} 
                  key={index}
                  onClick={(e) => handleLinkClick(e, option)}
                >
                  <div
                    key={index + 'pregacenter'}
                    className=' text-[#9D8F93] hover:text-primary text-lg'
                  >
                    {option.title}
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className='flex flex-col gap-4'>
            <h2 className=' text-white text-xl font-semibold'>
              {navLinks.resources.title}
            </h2>
            <div className='flex flex-col gap-2'>
              {navLinks.resources.navOptions.map((option, index) => (
                <Link 
                  to={option.link} 
                  key={index}
                  onClick={(e) => handleLinkClick(e, option)}
                >
                  <div
                    key={index + 'resources'}
                    className='text-[#9D8F93] hover:text-primary text-lg'
                  >
                    {option.title}
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className='flex flex-col gap-4'>
            <h2 className=' text-white text-xl font-semibold'>
              {navLinks.connect.title}
            </h2>
            <div className='flex flex-col gap-2'>
              {navLinks.connect.navOptions.map((option, index) => (
                <Link 
                  to={option.link} 
                  key={index}
                  onClick={(e) => handleLinkClick(e, option)}
                >
                  <div
                    key={index + 'connect'}
                    className=' text-[#9D8F93] hover:text-primary text-lg'
                  >
                    {option.title}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <h1 className='text-[#816F74] text-center text-[16px] text-wrap container'>
        Copyright © {new Date().getFullYear()} PregaCenter. All Rights Reserved
      </h1>
    </footer>
  );
};

export default Footer;
